import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'repaymentAgreements.deleteModal.title',
    defaultMessage: 'Remove Repayment Agreement',
  },
  confirmationText: {
    id: 'repaymentAgreements.deleteModal.confirmationText',
    defaultMessage:
      'Are you sure you want to remove this repayment agreement from the voucher?',
  },
  warningBanner: {
    id: 'repaymentAgreements.deleteModal.warningBanner',
    defaultMessage:
      'Removing this repayment will remove it from the current voucher only. If the voucher has already ' +
      'been submitted, it will be returned to Draft and a new submission will be required.',
  },
  cancel: {
    id: 'repaymentAgreements.deleteModal.cancel',
    defaultMessage: 'Cancel',
  },
  confirm: {
    id: 'repaymentAgreements.deleteModal.confirm',
    defaultMessage: 'Confirm',
  },
});
